<template>
    <a-layout style="min-height: 100vh;"  >
        <a-layout-sider width="250" style="position: fixed;height: 100vh; overflow: auto" class="basic_layout-layout_sider">
            <div style="height: 50px;display: flex; flex-direction: column; align-items: center;justify-content: center;">
                <img src="~@/assets/images/base-logo.png" class="logo" alt="logo" style="margin-top: 5px;height: 30px;cursor: pointer;" @click="skip_url('/login')">
            </div>
            <hr style="background-color: black;border: none;height: 2px;">

            <a-menu theme="dark" mode="inline" :selectedKeys="selectedKeys" :openKeys="openkeys" @openChange="openChange" class="BasicLayout_amenu">
                <template v-for="(value, index) in router_list">

                    <a-menu-item v-if="value['children'].length == 0" @click="skip_url(value['path'])" :key="value['path']" >
                        <span :style="{fontSize: global_fontsize + 'px', }">{{value['meta']['title']}}</span>
                    </a-menu-item>

                    <a-sub-menu v-if="value['children'].length != 0&&role_check(value['meta']['role'])" :key="`${index}_1`" >
                        <template #title>
                            <span :style="{fontSize: global_fontsize + 'px', }">{{value['meta']['title']}}</span>
                        </template>
                        <div v-for="(value2, index2) in value['children']">
                            <a-menu-item :key="value2['path']"  @click="skip_url(value2['path'])" :style="{fontSize: global_fontsize + 'px', }" v-if="role_check(value2['meta']['role'])">
                                <a-tooltip placement="rightTop" :title="value2['meta']['title']"  :mouseLeaveDelay="0"><span>{{ value2['meta']['title'] }}</span></a-tooltip>
                            </a-menu-item>
                        </div>
                    </a-sub-menu>

                </template>
            </a-menu>
        </a-layout-sider>
        <a-layout style="margin-left: 250px;">
            <a-layout-header style="background: 001529; padding: 0;height: 50px; display:flex; justify-content: flex-end; align-items: center;" >

                <div style="height: 100%;display: flex;align-items: center;margin-right: 10px;">

                    <a-popover>
                        <template #content >

                            <div style="display: flex;align-items: center;justify-content: center;">
                                <span :style="{fontSize: Number(5) + Number(global_fontsize) + 'px', }">{{ user_data.username }}</span>
                            </div>

                            <a-menu
                                style="width: 250px;font-size: 18px;display:flex;align-items: center;flex-direction: column;"
                                mode="vertical"
                                :dashed="true"
                                v-model:selectedKeys="user_operate_select_key"
                                @select="()=>{this.user_operate_select_key=[]}"
                            >

                                <a-upload v-if="Object.keys(user_data).length" :fileList="upload_profile_picture_file" @change="upload_change" :before-upload="()=>{return false}" :showUploadList="false" style="display: flex;flex-direction: column;width: 100%; height: 100%;">
                                    <a-menu-item :key="`user_operate_1`">
                                        <UploadOutlined /><span :style="{fontSize: global_fontsize + 'px', }">Upload profile picture</span>
                                    </a-menu-item>
                                </a-upload><hr style="width: 90%;margin: 0px;align-self: center;">

                                <a-menu-item @click="skip_url('/login')" :key="`user_operate_2`">
                                    <LogoutOutlined />
                                    <span v-if="Object.keys(user_data).length" :style="{fontSize: global_fontsize + 'px', }" >Sign out</span>
                                    <span v-if="!Object.keys(user_data).length" :style="{fontSize: global_fontsize + 'px', }" >Sign in</span>
                                </a-menu-item><hr style="width: 90%;margin: 0px;">

                            </a-menu>
                        </template>
                        
                        <img v-if="user_pic" :src="`${AXIOS_API}/info_management/get_avatar?pic=${user_pic}`"
                             style="border-radius: 50%;height: 40px;width: 40px;cursor: pointer;" />
                        <UserOutlined v-else style="background-color: #87d068;font-size: 30px;border-radius: 50%;" />

                    </a-popover>

                </div>

                <div style="height: 100%;display: flex;align-items: center;margin-right: 50px;">
                    <a-popover trigger="click">
                        <template #title>
                            <span style="font-size: 20px;">Font Size</span>
                        </template>
                        <template #content >
                            <div style="display: flex;justify-content: space-between;align-items: center;">
                                <div style="height: 25px;width: 25px;" :style="icon_reduce_style" @mouseenter="() => {icon_config['reduce'] = true}" @mouseleave="() => {icon_config['reduce'] = false}" @click="fontsize_add_reduce(-1)">
                                    <MinusOutlined style="cursor: pointer;font-size: 25px;" />
                                </div>

                                <span :style="{fontSize: 25+'px',}">{{ global_fontsize }}</span>

                                <div style="height: 25px;width: 25px;" :style="icon_add_style" @mouseenter="() => {icon_config['add'] = true}" @mouseleave="() => {icon_config['add'] = false}" @click="fontsize_add_reduce(1)">
                                    <PlusOutlined style="cursor: pointer; font-size: 25px" />
                                </div>

                                <a-button type="primary" style="border-radius: 25px;height: 40px;width: 60px;padding: 0;font-size: 18px;" @click="reset_fontsizt">reset</a-button>
                            </div>
                        </template>
                        <ZoomInOutlined style="color: rgb(179, 174, 174);font-size: 30px;" />
                    </a-popover>
                </div>

            </a-layout-header>
            <a-layout-content :style="{margin: background_black_url.includes(this.$route.path) ? 0 : '0 16px'}">
                <div :style="{ padding: '24px', minHeight: '360px', overflow: 'auto', height: '100%', background: background_black_url.includes(this.$route.path) ? 'black': '#fff'}">
                    <router-view :key="`${refreshkey}_${$route.fullPath}`" ></router-view>
                    <!-- 通过key和url来刷新组件 -->
                </div>
            </a-layout-content>
        </a-layout>

    </a-layout>

</template>
<script>
import { routes } from '@/components/router/index.js'
import {useRouter} from 'vue-router'
import { toRaw } from '@vue/reactivity';
import {LogoutOutlined, UploadOutlined} from '@ant-design/icons-vue';
import { AXIOS_API } from '@/views/storege/index'
export default {
    data(){
        return{
            AXIOS_API: AXIOS_API,
            router_list: [],
            background_black_url: ['/demo-video', '/reels-video', '/bts-video'],
            global_fontsize: 14,
            refreshkey: 0,
            icon_config: {
                'add': false,
                'reduce': false
            },
            user_pic: null,
            upload_profile_picture_file: [],
            user_operate_select_key: [],
            user_data: {}
        }
    },
    created(){
        sessionStorage.setItem("global_fontsize", this.global_fontsize)
        this.init_layout()
        let storage_user_data = JSON.parse(sessionStorage.getItem('user_data'))
        if (storage_user_data){
            this.user_data = storage_user_data
        }
        if(this.user_data.pic_url){
            this.user_pic = this.user_data['pic_url']
        }
        
    },
    computed: {
        icon_add_style(){
            if (this.icon_config['add']){
                return {backgroundColor: 'rgb(185, 183, 183)', borderRadius: 50+'%', }
            }
            return {}
        },
        icon_reduce_style(){
            if (this.icon_config['reduce']){
                return {backgroundColor: 'rgb(185, 183, 183)', borderRadius: 50+'%', }
            }
            return {}
        },
        // 导航栏选项
        selectedKeys(){
            return [this.$route.path]
        },
        // 导航栏展开选项
        openkeys(){
            let openKeys = sessionStorage.getItem('layouts_openKeys')
            if(openKeys){
                return openKeys.split(',')
            }else{
                return  ['0_1']
            }
        }
    },  
    methods:{
        init_layout(){
            let router = JSON.parse(JSON.stringify(routes))
            console.log('router', router)
            for(let i=0; i<router.length;i++){
                if(!router[i]['hidemenu']){

                    if('children' in router[i] && router[i]['children']){
                        for(let i1=0; i1<router[i]['children'].length;i1++){
                            if(!router[i]['children'][i1]['hidemenu']){
                                this.router_list.push(router[i]['children'][i1])
                                this.router_list = JSON.parse(JSON.stringify(this.router_list))
                                this.router_list[this.router_list.length-1]['children'] = []
                                
                                if('children' in router[i]['children'][i1] && router[i]['children'][i1]['children']){
                                    for(let i2=0; i2<router[i]['children'][i1]['children'].length;i2++){

                                        if(!router[i]['children'][i1]['children'][i2]['hidemenu']){
                                            this.router_list[this.router_list.length-1]['children'].push(router[i]['children'][i1]['children'][i2])
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

        },
        skip_url(url){
            // 当即将要跳转的url与当前的url相同时，只刷新router-view组件
            if(url == this.$route.fullPath){
                this.refreshkey++
            }else{
                this.$router.push(url)
            }
        
        },
        fontsize_add_reduce(value){
            this.global_fontsize += value
            this.default_font += value
            sessionStorage.setItem("global_fontsize", this.global_fontsize)
            this.refreshkey++
        },
        reset_fontsizt(){
            this.global_fontsize = JSON.parse(JSON.stringify(this.$options.data().global_fontsize))
            sessionStorage.setItem("global_fontsize", this.global_fontsize)
            this.refreshkey++
        },
        role_check(title_role){
            if(!title_role){
                return true
            }
            let title_role_data = toRaw(title_role)
            let user_data = JSON.parse(sessionStorage.getItem('user_data'))
            if (!user_data){
                return false
            }
            if (title_role_data.includes(user_data.role_id)){
                return true
            }
        },
        upload_upload_profile_picture(){
            let form_data = new FormData();
            form_data.append('pic', this.upload_profile_picture_file[0].originFileObj)
            this.$axios.request({
                method: 'post',
                url: `${AXIOS_API}/info_management/upload_avatar`,
                data: form_data}
            ).then((response)=> {
                if(response.data.code== 200){
                    this.$message.success(response.data.message)
                    this.user_pic = `${response.data.data.new_user_pic}`
                }
            })
        },
        // upload组件自定义添加(文件上传中、完成、失败都会调用这个函数)
        upload_change(value){
            if(this.upload_profile_picture_file.length === 0){
                this.upload_profile_picture_file = value.fileList
                this.$options.methods.upload_upload_profile_picture.bind(this)()
                this.upload_profile_picture_file = []
            }
        },
        // 当导航栏菜单项展开关闭时, 调用的事件
        openChange(openKeys){
            sessionStorage.setItem("layouts_openKeys", openKeys)
        }
    },
    // 在当前页面关闭时, 并且清空session
    beforeUnmount(){
        sessionStorage.clear()
    },
}
</script>

<style scoped>
/* 针对该容器的滚动条 */
.basic_layout-layout_sider::-webkit-scrollbar {
    width: 6px;
}

.basic_layout-layout_sider::-webkit-scrollbar-thumb {
    background: #1677ff;
    border-radius: 3px;
}

.basic_layout-layout_sider::-webkit-scrollbar-track {
    background: #f0f0f0;
}
</style>